import { render, staticRenderFns } from "./DeleteServiceProvide.vue?vue&type=template&id=2a3f4f0c"
import script from "./DeleteServiceProvide.vue?vue&type=script&lang=js"
export * from "./DeleteServiceProvide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports